import { css } from 'lit';
export default css `
  wui-loading-spinner {
    margin: 9px auto;
  }
`;
//# sourceMappingURL=styles.js.map